<template>
  <div class="flex flex-col gap-4">
    <h3 class="text-[20px] font-bold">Ik zet alles voor je op een rij</h3>
    <ul class="flex flex-col gap-4">
      <li
        v-for="(step, index) in CALCULATION_STEPS"
        :key="step.label"
        class="step-item flex items-center gap-4"
        :style="{ animationDelay: `${index * 80}ms` }"
      >
        <span
          class="flex size-[30px] shrink-0 items-center justify-center rounded-full text-[13px] font-bold text-white transition-colors duration-500"
          :class="[
            circleClass(animation.stepState(index)),
            { 'step-circle-active': animation.stepState(index) === 'active' },
          ]"
        >
          <!-- Thicker stroke than the button check: this one is smaller, this keeps the visual weight equal. -->
          <CheckIcon
            v-if="animation.stepState(index) === 'done'"
            class="step-check size-3.5"
            stroke-width="3.5"
            aria-hidden="true"
          />
          <!-- The running step shows a spinner, and the check only lands when it completes: the
               loader-then-check rhythm from the briefing (#6331). -->
          <span
            v-else-if="animation.stepState(index) === 'active'"
            class="size-3.5 rounded-full border-2 border-white/40 border-t-white motion-safe:animate-spin"
            aria-hidden="true"
          />
          <template v-else>{{ index + 1 }}</template>
        </span>
        <span
          class="text-base font-normal transition-colors duration-500"
          :class="animation.stepState(index) === 'todo' ? 'text-muted' : 'text-label'"
        >
          {{ step.label }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import CheckIcon from '@/assets/svg/check.svg?component'
import { CALCULATION_STEPS, type StepState, useAnimationStore } from '@/stores/animation'

const animation = useAnimationStore()

function circleClass(state: StepState): string {
  if (state === 'done') {
    return 'bg-orange'
  }

  return state === 'active' ? 'bg-blue-bright' : 'bg-blue-soft/50'
}
</script>
